// extracted by mini-css-extract-plugin
export var changeIcon = "_4g-4";
export var container = "_4g-0";
export var divider = "_4g-7";
export var externalLinkIcon = "_4g-1";
export var green = "_4g-5";
export var helpCircleIcon = "_4g-3";
export var iconButton = "_4g-2";
export var red = "_4g-6";